import React from 'react';
import { useTranslate } from 'nucleus-text';
import { Col } from '@cvent/carina/components/Col';
import Button from '@cvent/carina/components/Button';
import { injectTestId } from '@cvent/nucleus-test-automation';
import FullscreenModal from '@components/layout/FullscreenModal';
import useBreakpoints from '@hooks/useBreakpoints';
import lineClamp from '@tools/lineClamp';
import { isMobileSafari } from 'react-device-detect';
import { CSSObject } from '@emotion/react';
import { MoodThemeProvider } from '@components/blocks/BlockThemeProvider';

const useStyles = (): Record<string, CSSObject> => {
  const { isMobile } = useBreakpoints();

  return {
    contentStyle: {
      wordWrap: 'break-word'
    },
    buttonRowStyle: {
      margin: 24,
      marginTop: 16,
      marginBottom: isMobileSafari ? 72 : 24,
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'flex-end'
    }
  };
};

interface TermsAndConditionsProps {
  title: string;
  terms: string;
  onAccept: () => void;
  onDecline: () => void;
}

function TermsAndConditions({ title, terms, onAccept, onDecline }: TermsAndConditionsProps) {
  const { translate } = useTranslate();
  const { buttonRowStyle, contentStyle } = useStyles();

  return (
    <MoodThemeProvider>
      <FullscreenModal
        disableFocusTrap
        testID="terms-modal"
        header={<div css={lineClamp(2)}>{title}</div>}
        content={
          <p css={contentStyle} {...injectTestId('terms-body')}>
            {terms}
          </p>
        }
        footer={
          <div css={buttonRowStyle}>
            <Col width="content">
              <Button testID="terms-decline" text={translate('terms-decline')} onClick={onDecline} />
            </Col>
            <Col width="content">
              <Button testID="terms-accept" text={translate('terms-accept')} appearance="filled" onClick={onAccept} />
            </Col>
          </div>
        }
        ariaLabel={translate('Terms-and-Conditions-Modal-Aria-Label')}
      />
    </MoodThemeProvider>
  );
}

export default TermsAndConditions;
